var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M98.895,31V25.527h1.769l.265-2.134H98.895V22.031c0-.618.164-1.038,1.018-1.038H101V19.084A14.2,14.2,0,0,0,99.416,19a2.525,2.525,0,0,0-2.642,2.82v1.573H95v2.134h1.774V31Z",
    transform: "translate(-95 -19)",
    fill: "#9fa2a5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.11788440ca5b9ee536d32bc378fd6853.svg";
export { ForwardRef as ReactComponent };